import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { AuthHeaders } from '../../../models/auth-headers';
import { ssoUserSchema } from '../schemas/sso-user.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Create a new SSO user and associate them with an account/product and assign a role
 * @param accountId Id of the account
 * @param product Trimble Maps product name
 * @param role Role to assign the user
 * @param request.email user's email or username
 * @param request.firstName user's first name
 * @param request.lastName user's last name
 * @param request.password user's password (Optional)
 * @param request.alias account alias (only needed for non-email users)
 * @returns newly created user info
 */
export function postUsersAccountsProductRole(
  this: unknown,
  accountId: number,
  product: string,
  role: string,
  request: {
    email: string;
    firstName: string;
    lastName: string;
    password?: string;
    alias?: string;
  }
) {
  const params = new URLSearchParams([['role', role]]);
  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).usersUrl
      }/accounts/${encodeURIComponent(accountId)}/products/${encodeURIComponent(
        product
      )}?${params.toString()}`,
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: JSON.stringify(request),
      }
    )
  ).pipe(selectData(ssoUserSchema));
}
